import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/** 海南资料收集列表 */
export async function queryHainanDataCollectionList(params: any) {
  try {
    let data = [] as any[];
    let total = 0;
    const { code, context, message } = await Http.post<{ data: any[]; total: number }>(
      `${hostUrl}/side/company/contractCollect/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: any[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 新增海南资料
 * @param params 保存参数
 */
export async function addHainanDataCollection(params: { id: string }) {
  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/side/company/contractCollect/invoice`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 删除海南资料
 * @param params 保存参数
 */
export async function deleteHainanDataCollection(params: { idList: any }) {
  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/side/company/contractCollect/pre`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/** 结算说明列表 */
export async function queryRemarkConfigList(params: any) {
  try {
    let data = [] as any[];
    let total = 0;
    const { code, context, message } = await Http.post<{ data: any[]; total: number }>(
      `${hostUrl}/side/company/orderRemark/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: any[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 新增结算说明
 * @param params 保存参数
 */
export async function addRemarkConfig(params: { id: string }) {
  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/side/company/showOrderRemark`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 删除结算说明
 * @param params 保存参数
 */
export async function deleteRemarkConfig(params: { idList: any }) {
  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/side/company/showOrderRemarkOff`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}